import { render, staticRenderFns } from "./ViewAcknowledgeProblemAll.vue?vue&type=template&id=b33ebac6&"
import script from "./ViewAcknowledgeProblemAll.vue?vue&type=script&lang=js&"
export * from "./ViewAcknowledgeProblemAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports